<template>
  <div class="product-slider">
    <div
      v-for="(video, idx) in videos"
      :key="idx"
      class="product-slider__item"
      :class="{ 'is-selected': index === idx }"
    >
      <video
        :src="video"
        :poster="poster"
        playsinline
        muted
        loop
        @click="playVideo(idx)"
        ref="videoPlayer"
      ></video>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    flickity: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      videos: [],
      poster: ''
    }
  },
  mounted() {
    if (this.flickity) {
      this.flickity.on('change', this.onSlideChange)
    }
  },
  beforeDestroy() {
    if (this.flickity) {
      this.flickity.off('change', this.onSlideChange)
    }
  },
  methods: {
    onSlideChange(index) {
      this.pauseAllVideos()
    },
    playVideo(idx) {
      const video = this.$refs.videoPlayer[idx]
      if (video) {
        if (video.paused) {
          video.play()
        } else {
          video.pause()
        }
      }
    },
    pauseAllVideos() {
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.forEach(video => {
          if (video && !video.paused) {
            video.pause()
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/ProductSlider.vue